import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=ef5d2430&scoped=true&"
import script from "./EditIcon.vue?vue&type=script&lang=ts&"
export * from "./EditIcon.vue?vue&type=script&lang=ts&"
import style0 from "./EditIcon.vue?vue&type=style&index=0&id=ef5d2430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5d2430",
  null
  
)

export default component.exports